import React, { useEffect } from 'react';
import './LegalPage.css';

function PrivacyPage() {
  useEffect(() => {
    document.title = '개인정보처리방침 - 로또운세';
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>🔒 개인정보처리방침</h1>
        <p className="updated-date">최종 수정일: 2026년 2월 17일</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. 개인정보의 수집 및 이용 목적</h2>
          <p>
            로또운세(이하 "서비스")는 사용자의 개인정보를 매우 중요하게 생각하며,
            개인정보 보호법을 준수하고 있습니다. 본 서비스는 다음과 같은 목적으로
            개인정보를 처리합니다:
          </p>
          <ul>
            <li>로또 번호 생성 및 저장 서비스 제공</li>
            <li>운세 콘텐츠 제공 및 맞춤형 서비스 제공</li>
            <li>서비스 개선 및 통계 분석</li>
            <li>문의사항 처리 및 고객 지원</li>
          </ul>
        </section>

        <section>
          <h2>2. 수집하는 개인정보 항목</h2>
          <p>본 서비스는 최소한의 개인정보만을 수집합니다:</p>
          <ul>
            <li><strong>자동 수집 정보:</strong> IP 주소, 쿠키, 방문 기록, 서비스 이용 기록</li>
            <li><strong>선택적 정보:</strong> 사용자가 저장한 로또 번호 (로컬 스토리지)</li>
            <li><strong>문의 시:</strong> 이메일 주소, 문의 내용 (사용자가 제공하는 경우)</li>
          </ul>
        </section>

        <section>
          <h2>3. 개인정보의 보유 및 이용 기간</h2>
          <p>
            수집된 정보는 서비스 제공 목적 달성 시까지 보유하며, 관련 법령에 따라
            보존이 필요한 경우 해당 기간 동안 보관합니다.
          </p>
          <ul>
            <li>로컬 스토리지 데이터: 사용자가 직접 삭제하기 전까지</li>
            <li>방문 기록: 1년</li>
            <li>문의 내용: 답변 완료 후 1년</li>
          </ul>
        </section>

        <section>
          <h2>4. 개인정보의 제3자 제공</h2>
          <p>
            본 서비스는 사용자의 개인정보를 원칙적으로 제3자에게 제공하지 않습니다.
            다만, 다음의 경우 예외로 합니다:
          </p>
          <ul>
            <li>사용자의 사전 동의가 있는 경우</li>
            <li>법령에 의해 요구되는 경우</li>
            <li>Google AdSense: 광고 게재를 위한 익명화된 데이터</li>
          </ul>
        </section>

        <section>
          <h2>5. 쿠키의 사용</h2>
          <p>
            본 서비스는 사용자 경험 개선과 맞춤형 콘텐츠 제공을 위해 쿠키를 사용합니다.
            사용자는 브라우저 설정을 통해 쿠키 사용을 거부할 수 있으나,
            일부 서비스 이용에 제한이 있을 수 있습니다.
          </p>
        </section>

        <section>
          <h2>6. 사용자의 권리</h2>
          <p>사용자는 다음과 같은 권리를 가집니다:</p>
          <ul>
            <li>개인정보 열람 요구권</li>
            <li>개인정보 정정 요구권</li>
            <li>개인정보 삭제 요구권</li>
            <li>개인정보 처리 정지 요구권</li>
          </ul>
        </section>

        <section>
          <h2>7. 개인정보 보호책임자</h2>
          <p>
            개인정보 보호와 관련한 문의사항은 아래 연락처로 문의해 주시기 바랍니다:
          </p>
          <ul>
            <li>이메일: contact@zipyo.kr</li>
            <li>응답 시간: 영업일 기준 3일 이내</li>
          </ul>
        </section>

        <section>
          <h2>8. 개인정보처리방침 변경</h2>
          <p>
            본 개인정보처리방침은 법령, 정책 또는 보안 기술의 변경에 따라
            내용이 수정될 수 있으며, 변경 시 웹사이트를 통해 공지합니다.
          </p>
        </section>

        <section className="notice-box">
          <h3>⚠️ 중요 안내</h3>
          <p>
            본 서비스는 로또 번호를 사용자의 브라우저 로컬 스토리지에만 저장하며,
            서버에는 저장하지 않습니다. 따라서 브라우저 데이터를 삭제하면
            저장된 번호도 함께 삭제됩니다.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPage;
